import { GreetingMessage, getGreetingEndpoint } from 'cpes-common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<GreetingMessage, DefaultBusinessMarketApiErrorCode>({
    dataName: 'greeting',
    fetchCallback() {
        return CpDataApi.get<GreetingMessage>(getGreetingEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchGreeting = fetchData;
